const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="kt-subheader kt-grid__item" id="kt_subheader">
      <div className="kt-container kt-container--fluid">
        <div className="kt-subheader__main">
          <h3 className="kt-subheader__title">{title}</h3>
          <span className="kt-subheader__separator kt-hidden" />
          <div className="kt-subheader__breadcrumbs">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="kt-subheader__breadcrumbs-home">
              <i className="flaticon2-shelter" />
            </a>
            <span className="kt-subheader__breadcrumbs-separator" />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href=""
              onClick={(e) => e.preventDefault()}
              className="kt-subheader__breadcrumbs-link"
            >
              {subtitle}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
